import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ContactFormModal from './contact_form_modal';

export function ContactFormModalLink({ contact, label }) {
  const [showContactEditModal, setShowContactEditModal] = useState();

  const hideModal = () => {
    setShowContactEditModal(false);
  };

  return <React.Fragment>
    <div>
      <a className="clickable" name="edit-contact" onClick={() => setShowContactEditModal(true)}>
        {label}
      </a>
    </div>

    <ContactFormModal
      contact={contact}
      show={showContactEditModal}
      onHide={hideModal}
    />
  </React.Fragment>;
}

ContactFormModalLink.propTypes = {
  contact: PropTypes.shape({
    contactType: PropTypes.string.isRequired,
    id: PropTypes.number,
    localId: PropTypes.string,
  }).isRequired,
  label: PropTypes.string,
};

export default ContactFormModalLink;
